import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
// @ts-ignore
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from "../../../../environments/environment";
import { AlertService } from "../../../shared/services/alert/alert.service";
import { AuthService } from "../../auth/auth.service";
import { DATASOURCE_ROOT_CONFIG, DatasourceConfig } from "../datasource.config";
import { DataSource, DatasourceAPI, DatasourceOption } from "./datasource.model";

@Injectable({
	providedIn: 'root'
})
export class DatasourceService {

	constructor(
		private authService: AuthService,
		private _http: HttpClient,
		@Inject(DATASOURCE_ROOT_CONFIG) private _dsConfig: DatasourceConfig,
		private alertService: AlertService,
		private _spinner: NgxSpinnerService
	) {
		this._setBaseHrefToUrls();
	}

	request(id: string, action: string = '', options: DatasourceOption = {},
					staticOptions: { onError?: BehaviorSubject<any>, showError?: boolean } = {showError: true}): Observable<any> {
		const ds = this._dsConfig.datasources[id];
		// console.log('id', id, action, options, ds);
		if (ds.items) {
			return of(ds.items);
		}

		const api = this.getDatasourceApi(id, action);
		const url = this._resolveUrl(api, options);

		const requestOptions = this._resolveReqOptions(options);

		// console.log('requestOptions', requestOptions);
		// console.log('request', api, url, requestOptions);
		if (!!options.loading) {
			this._spinner.show();
		}
		return this._http.request(api.method, url, requestOptions)
			.pipe(
				tap((response: any) => {
					if (!!response.code && response.code !== 200) {
						if (response.message) {
							this.alertService.pushError('Error', response.message);
						}
						throw response;
					}
					if (!!options.msg && !!options.msg['OK']) {
						this.alertService.pushError('Correcto', options.msg['OK']);
					}
					if (!!options.loading) {
						this._spinner.hide();
					}

				}),
				catchError((err: HttpErrorResponse | any) => {
					console.log('', err);
					this._spinner.hide();

					if (staticOptions.onError) {
						staticOptions.onError.next(true);
					}
					if (staticOptions.showError) {
						if (!!options.msg && !!options.msg['ERROR']) {
							this.alertService.pushError('Error', options.msg['ERROR']);
						} else {
							if (err.data) {
								this.alertService.pushError('Error', err.data);
							} else {
								this.alertService.pushError('Error', `Error en la petición ${api.name}`);
							}
						}
					}
					throw err;
				})
			);
	}


	get(model: string): DataSource {
		return this._dsConfig.datasources[model];
	}


	getDatasourceApi(model: string, action: string): DatasourceAPI {
		return this.get(model).api[action];
	}


	baseHref() {
		return this._dsConfig.baseAbsoluteUrl;
	}


	_resolveUrl(api: DatasourceAPI, options: DatasourceOption): string {
		const url = api.url;

		if (!options.urlParams) {
			// Si no tiene configurado branch o product, o no esta en la url,  devuelve la url , sino le agrega
			// un objeto urlParams para configurarlo
			if (!api.product && !api.branch && url.indexOf('{branch}') < 0 && url.indexOf('{product}') < 0) {
				return url;
			} else {
				options.urlParams = {};
			}
		}

		// Si la url tiene el parametro branch o el parametro modulo se asignan desde el enviroment
		if (!!api.branch || url.indexOf('{branch}') > -1) {
			options.urlParams = {...options.urlParams, branch: environment.paramsConfig.branch.code};
		}
		if (!!api.product || url.indexOf('{product}') > -1) {
			options.urlParams = {...options.urlParams, product: environment.paramsConfig.product.code};
		}
		return this._resolveUrlParams(url, options.urlParams);
	}


	private _resolveParams(options: DatasourceOption): HttpParams {

		let config = {};
		const queryParams = options.queryParams;

		if (options.queryParams) {
			config = Object.assign({}, config, queryParams);
		}

		let params = new HttpParams();
		const keys = Object.keys(config);

		for (let i = 0; i < keys.length; i++) {
			const newParam: any = config[keys[i]];
			params = params.append(keys[i], newParam);
		}

		return params;
	}

	private _resolveHeaders(file = false): HttpHeaders {

		// let headers = new HttpHeaders();
		let headers = this.authService.signRequest(new HttpHeaders());
		if (!file) {
			headers = headers.set('Content-Type', 'application/json');
		}
		// console.log('headers', headers);
		return headers;
	}

	private _resolveUrlParams(url: string, urlParams: any) {

		return Object.keys(urlParams).reduce((_url, key) => {
			return _url.replace(new RegExp('{' + key + '}', 'g'), urlParams[key]);
		}, url);
	}

	private _resolveBodyParam(options: DatasourceOption) {
		return options.body || {};
	}

	private _resolveReqOptions(options: DatasourceOption, file = false) {

		return {
			params: this._resolveParams(options),
			headers: this._resolveHeaders(file),
			body: this._resolveBodyParam(options)
		};

	}

	private _setBaseHrefToUrls() {

		const absUrl = this.baseHref();
		const dsIds = Object.keys(this._dsConfig.datasources);


		for (let i = 0; i < dsIds.length; i++) {
			const datasource = this.get(dsIds[i]);
			const api = this.get(dsIds[i]).api;

			if (!api) {
				continue;
			}

			const actions = Object.keys(api);

			for (let j = 0; j < actions.length; j++) {

				const action = api[actions[j]];

				if (action.url.indexOf(absUrl) < 0) {
					if (!action.skip) {
						action.url = datasource.url + action.url;
					}
				}

			}
		}
	}

}
